// extracted by mini-css-extract-plugin
export default {"MainDiv":"InProgressOrder_MainDiv__WXRQ+","TableDiv":"InProgressOrder_TableDiv__W5AN9","TableButton":"InProgressOrder_TableButton__52HYK"};